export enum CommonGenericEvents {
	ERROR_500 = 'error_500',
	HORIZONTAL_SCROLL = 'horizontal_scroll',
}
